import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../../../components/feature/Navbar';
import Footer from '../../../../components/feature/Footer';

const SentinelKurulumRehberiPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-16 bg-gradient-to-br from-[#0078D4] to-[#005A9E] overflow-hidden">
        <div className="absolute inset-0 bg-black/20" />
        <div className="absolute inset-0 opacity-10">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(255,255,255,0.1) 2px, rgba(255,255,255,0.1) 4px)',
            }}
          />
        </div>
        <div className="relative max-w-4xl mx-auto px-8">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <Link
              to="/sentinel"
              className="inline-flex items-center space-x-2 text-white/80 hover:text-white text-sm font-medium mb-8 cursor-pointer transition-colors"
            >
              <i className="ri-arrow-left-line text-lg"></i>
              <span>Sentinel Sayfasına Dön</span>
            </Link>

            <div className="flex items-center space-x-3 mb-6">
              <span className="px-3 py-1 bg-white/20 backdrop-blur-sm rounded-md text-white text-xs font-semibold uppercase tracking-wider whitespace-nowrap">
                Kurulum Rehberi
              </span>
              <span className="px-3 py-1 bg-white/20 backdrop-blur-sm rounded-md text-white text-xs font-semibold uppercase tracking-wider whitespace-nowrap">
                Microsoft Sentinel
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-6">
              Microsoft Sentinel Kurulum Rehberi: İlk 24 Saatte Atılması Gereken Adımlar
            </h1>

            <div className="flex items-center space-x-6 text-white/70 text-sm">
              <div className="flex items-center space-x-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-calendar-line text-base"></i>
                </div>
                <span>5 Mayıs 2025</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-time-line text-base"></i>
                </div>
                <span>Makale</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-user-line text-base"></i>
                </div>
                <span>Özgür Çebi</span>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Makale İçeriği */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-8">
          <motion.article
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="prose prose-lg max-w-none"
          >
            <div className="text-gray-700 leading-relaxed space-y-6">
              <p className="text-lg">
                Siber güvenlik dünyasında hız her şeydir. Ancak yanlış yapılandırılmış bir SIEM (Security Information and Event Management), çözümden ziyade bir "maliyet ve gürültü merkezi" haline gelebilir. Sentinel yolculuğunuzun ilk 24 saatini nasıl optimize etmeniz gerektiğini adım adım inceleyelim.
              </p>

              {/* Görsel */}
              <div className="my-10">
                <img
                  src="https://public.readdy.ai/ai/img_res/6945bdc8b00d07724b8e55e583c47fc0.jpg"
                  alt="Sentinel Kurulum İllüstrasyonu"
                  className="w-full h-auto rounded-2xl shadow-lg object-top"
                />
              </div>

              {/* Prerequisites */}
              <section className="mb-12">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Ön Gereksinimler</h2>
                
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
                    <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                      <i className="ri-cloud-line text-2xl text-purple-600"></i>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-3">Azure Aboneliği</h3>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start">
                        <i className="ri-check-line text-purple-600 mr-2 mt-0.5"></i>
                        <span>Aktif Azure aboneliği</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-purple-600 mr-2 mt-0.5"></i>
                        <span>Kaynak grubu oluşturma yetkisi</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-purple-600 mr-2 mt-0.5"></i>
                        <span>Log Analytics workspace yetkisi</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                      <i className="ri-shield-user-line text-2xl text-blue-600"></i>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-3">Gerekli İzinler</h3>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start">
                        <i className="ri-check-line text-blue-600 mr-2 mt-0.5"></i>
                        <span>Entra ID Global Admin veya Security Admin</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-blue-600 mr-2 mt-0.5"></i>
                        <span>Azure Contributor rolü</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-blue-600 mr-2 mt-0.5"></i>
                        <span>Microsoft Sentinel Contributor</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </section>

              <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6 flex items-center">
                <span className="w-10 h-10 flex items-center justify-center bg-[#0078D4] text-white rounded-lg mr-4 text-xl">1</span>
                Mimari Temel: Log Analytics Workspace (LAW) Tasarımı
              </h2>

              <p>
                Sentinel'in kalbi Log Analytics Workspace'dir. İlk adımda yapılan hatalar, ileride veri izolasyonu veya aşırı maliyet olarak karşınıza çıkar.
              </p>

              <div className="grid grid-cols-1 gap-6 my-8">
                <div className="bg-white border border-gray-200 rounded-xl p-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#0078D4]/10 rounded-lg mb-4">
                    <i className="ri-global-line text-2xl text-[#0078D4]"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Bölge (Region) Seçimi</h3>
                  <p className="text-sm text-gray-600">Verinin işlendiği bölge ile Sentinel'in bulunduğu bölge aynı olmalıdır. Gecikme ve bant genişliği maliyetlerini azaltmak için kaynaklarınıza en yakın bölgeyi seçin.</p>
                </div>
                <div className="bg-white border border-gray-200 rounded-xl p-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#0078D4]/10 rounded-lg mb-4">
                    <i className="ri-money-dollar-circle-line text-2xl text-[#0078D4]"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Maliyet Yönetimi</h3>
                  <p className="text-sm text-gray-600">İlk gün "Commitment Tiers" (Taahhütlü Katmanlar) yerine "Pay-As-You-Go" ile başlayın. İlk 30 günün ardından veri hacminizi analiz ederek %60'a varan tasarruf sağlayan taahhütlü modellere geçiş yapabilirsiniz.</p>
                </div>
                <div className="bg-white border border-gray-200 rounded-xl p-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#0078D4]/10 rounded-lg mb-4">
                    <i className="ri-shield-user-line text-2xl text-[#0078D4]"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">RBAC (Rol Tabanlı Erişim Denetimi)</h3>
                  <p className="text-sm text-gray-600">Sadece "Sentinel Contributor" yetkisi yeterli değildir. Ekibinize işlevine göre; Sentinel Reader, Sentinel Responder veya Sentinel Contributor rollerini en az ayrıcalık (Least Privilege) prensibiyle dağıtın.</p>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6 flex items-center">
                <span className="w-10 h-10 flex items-center justify-center bg-[#0078D4] text-white rounded-lg mr-4 text-xl">2</span>
                İlk 4 Saat: Kritik Veri Kaynaklarının Bağlanması
              </h2>

              <p>
                Sentinel'i ayağa kaldırdıktan sonraki en kritik aşama, "Hangi veriyi içeri almalıyım?" sorusudur. MVP tavsiyesi olarak; "Ücretsiz ve Yüksek Değerli" kaynaklardan başlayın.
              </p>

              <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">A. Ücretsiz Kaynaklar (Hemen Bağlayın)</h3>
              <p>Aşağıdaki log kaynakları Sentinel veri alım (ingestion) maliyetine dahil değildir:</p>

              <div className="bg-green-50 border border-green-200 rounded-xl p-6 my-6">
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-green-600 text-xl mr-3 mt-1"></i>
                    <span><strong>Azure Activity Logs:</strong> Azure ortamınızdaki tüm yönetimsel hareketler.</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-green-600 text-xl mr-3 mt-1"></i>
                    <span><strong>Office 365 Audit Logs (SharePoint, Exchange, Teams):</strong> Kullanıcı aktivitelerini izlemek için kritiktir.</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-green-600 text-xl mr-3 mt-1"></i>
                    <span><strong>Microsoft Defender for Cloud Uyarıları:</strong> Mevcut güvenlik uyarılarının korelasyonu.</span>
                  </li>
                </ul>
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">B. Kritik Güvenlik Kaynakları</h3>

              <div className="space-y-4 my-6">
                <div className="bg-[#F0F6FF] border-l-4 border-[#0078D4] p-6 rounded-lg">
                  <h4 className="font-bold text-gray-900 mb-2">Microsoft Entra ID (Azure AD)</h4>
                  <p className="text-sm text-gray-700">Sign-in Logs ve Audit Logs. Kimlik saldırılarını tespit etmek için "olmazsa olmazdır".</p>
                </div>
                <div className="bg-[#F0F6FF] border-l-4 border-[#0078D4] p-6 rounded-lg">
                  <h4 className="font-bold text-gray-900 mb-2">Microsoft Defender XDR</h4>
                  <p className="text-sm text-gray-700">Uç nokta (Endpoint), e-posta ve kimlik verilerini Sentinel'e akıtmak için "Microsoft Defender XDR Connector"'ı kullanın. Bu, olayların (incidents) otomatik olarak senkronize edilmesini sağlar.</p>
                </div>
              </div>

              {/* Görsel - Veri Kaynakları */}
              <div className="my-10">
                <img
                  src="https://readdy.ai/api/search-image?query=Digital%20network%20diagram%20showing%20multiple%20data%20sources%20connecting%20to%20central%20security%20hub%2C%20modern%20tech%20illustration%20with%20flowing%20data%20streams%20and%20connection%20nodes%2C%20blue%20gradient%20background%20with%20glowing%20connection%20lines%2C%20abstract%20cybersecurity%20data%20integration%20concept&width=1200&height=600&seq=sentinel-data-sources&orientation=landscape"
                  alt="Veri Kaynakları Bağlantısı"
                  className="w-full h-auto rounded-2xl shadow-lg object-top"
                />
              </div>

              <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6 flex items-center">
                <span className="w-10 h-10 flex items-center justify-center bg-[#0078D4] text-white rounded-lg mr-4 text-xl">3</span>
                İlk 12 Saat: Content Hub ve Hazır Çözümler
              </h2>

              <p>
                Kendi kurallarınızı yazmaya başlamadan önce Microsoft'un sunduğu devasa kütüphaneden yararlanın.
              </p>

              <div className="bg-gradient-to-br from-[#0078D4] to-[#005A9E] text-white rounded-2xl p-8 my-8">
                <h3 className="text-2xl font-bold mb-6">Content Hub Kullanımı</h3>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-lg mr-4 flex-shrink-0 mt-1">
                      <i className="ri-download-cloud-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-white/90 text-sm">Bağladığınız veri kaynaklarına uygun (örn: "Microsoft Entra ID" veya "Cisco ASA") çözümleri Content Hub üzerinden yükleyin.</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-lg mr-4 flex-shrink-0 mt-1">
                      <i className="ri-shield-check-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="font-bold mb-1">Analytics Rules (Analiz Kuralları)</h4>
                      <p className="text-white/90 text-sm">Yüklediğiniz çözümlerle birlikte gelen şablonları (Templates) aktif edin. Başlangıçta çok fazla "False Positive" almamak için kuralları kademeli olarak devreye alın.</p>
                    </div>
                  </div>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6 flex items-center">
                <span className="w-10 h-10 flex items-center justify-center bg-[#0078D4] text-white rounded-lg mr-4 text-xl">4</span>
                İlk 24 Saat: Görünürlük ve Sağlık Kontrolü
              </h2>

              <p>
                Kurulumun ilk günü bitmeden sistemin doğru çalıştığından emin olmanız gerekir.
              </p>

              <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Veri Akış Kontrolü (Health Monitoring)</h3>
              <p>
                Sentinel'in kendi sağlığını izlemek için "Sentinel Health" özelliğini aktif edin. Bir konnektör durduğunda veya veri akışı azaldığında uyarı almanız operasyonel süreklilik için hayati önem taşır.
              </p>

              <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Kritik KQL Sorgusu</h3>
              <p>
                Verilerinizin gelip gelmediğini kontrol etmek için şu basit KQL (Kusto Query Language) kodunu "Logs" kısmında çalıştırın:
              </p>

              <div className="bg-gray-900 text-gray-100 rounded-xl p-6 my-6 overflow-x-auto">
                <pre className="text-sm font-mono">
                  <code>{`// Son 24 saatte en çok veri gönderen tabloları listeler
Usage
| where TimeGenerated > ago(24h)
| where IsBillable == true
| summarize TotalGB = sum(Quantity) / 1024 by DataType
| sort by TotalGB desc`}</code>
                </pre>
              </div>

              <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">
                &nbsp;Check-list
              </h2>

              <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 my-8">
                <ul className="space-y-4">
                  <li className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center border-2 border-[#0078D4] rounded mr-4 flex-shrink-0 mt-1">
                      <span className="text-xs text-[#0078D4]">✓</span>
                    </div>
                    <span className="text-gray-700"><strong>Workspace:</strong> Doğru bölge ve doğru RBAC yapılandırıldı mı?</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center border-2 border-[#0078D4] rounded mr-4 flex-shrink-0 mt-1">
                      <span className="text-xs text-[#0078D4]">✓</span>
                    </div>
                    <span className="text-gray-700"><strong>Konnektörler:</strong> Ücretsiz kaynaklar (Office 365, Activity) bağlandı mı?</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center border-2 border-[#0078D4] rounded mr-4 flex-shrink-0 mt-1">
                      <span className="text-xs text-[#0078D4]">✓</span>
                    </div>
                    <span className="text-gray-700"><strong>Entra ID:</strong> Kimlik logları akıyor mu?</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center border-2 border-[#0078D4] rounded mr-4 flex-shrink-0 mt-1">
                      <span className="text-xs text-[#0078D4]">✓</span>
                    </div>
                    <span className="text-gray-700"><strong>Analytics:</strong> Content Hub üzerinden en az 5 kritik kural aktif edildi mi?</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center border-2 border-[#0078D4] rounded mr-4 flex-shrink-0 mt-1">
                      <span className="text-xs text-[#0078D4]">✓</span>
                    </div>
                    <span className="text-gray-700"><strong>Maliyet:</strong> Günlük veri limiti (Daily Cap) olası bir maliyet şokunu önlemek için ayarlandı mı?</span>
                  </li>
                </ul>
              </div>

              <div className="bg-[#F0F6FF] border-l-4 border-[#0078D4] p-6 rounded-lg my-8">
                <p className="text-base font-semibold text-gray-900">
                  İlk 24 saat, Sentinel'in temelini oluşturur. Doğru mimari kararlar ve stratejik veri kaynağı seçimleri, ileride hem operasyonel verimliliği hem de maliyet kontrolünü sağlayacaktır.
                </p>
              </div>
            </div>
          </motion.article>
        </div>
      </section>

      {/* Alt Navigasyon */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-4xl mx-auto px-8">
          <div className="flex items-center justify-between">
            <Link
              to="/sentinel"
              className="inline-flex items-center space-x-2 px-6 py-3 bg-white border border-gray-200 rounded-lg hover:shadow-md transition-all cursor-pointer text-gray-700 hover:text-[#0078D4]"
            >
              <i className="ri-arrow-left-line text-lg"></i>
              <span className="text-sm font-medium whitespace-nowrap">Sentinel Sayfası</span>
            </Link>
            <Link
              to="/"
              className="inline-flex items-center space-x-2 px-6 py-3 bg-white border border-gray-200 rounded-lg hover:shadow-md transition-all cursor-pointer text-gray-700 hover:text-[#0078D4]"
            >
              <span className="text-sm font-medium whitespace-nowrap">Ana Sayfa</span>
              <i className="ri-arrow-right-line text-lg"></i>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SentinelKurulumRehberiPage;
